// extracted by mini-css-extract-plugin
export default {"answered":"answered__VWEO0","vItem":"vItem__c3nTu","vAnswered":"vAnswered__qVcL5","correct":"correct__kIzsr"};